"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultClassOverrideForItemDetail = void 0;
var react_1 = __importStar(require("react"));
var CopyIcon_1 = __importDefault(require("@components/CopyIcon"));
var react_i18next_1 = require("react-i18next");
var QuickAddToList_1 = __importDefault(require("@components/QuickAddToList"));
var overflow_1 = require("@/react-app/common/utils/overflow");
exports.defaultClassOverrideForItemDetail = {
    wrapperClassName: 'item-detail-field',
    labelClassName: 'item-detail-field__label',
    valueContainerClassName: 'item-detail-field-value-container',
    linkClassName: 'item-detail-field__value-link-internal',
    iconClassName: 'eva-job-key-value-item__icon-container',
    divClassName: 'item-detail-field__value-div',
};
function AdditionalInformationItem(_a) {
    var cyName = _a.cyName, label = _a.label, angularJsDependencies = _a.angularJsDependencies, value = _a.value, sanitizedValue = _a.sanitizedValue, searchText = _a.searchText, additionalIconsToRender = _a.additionalIconsToRender, chipsToRender = _a.chipsToRender, customValuesContainerClassName = _a.customValuesContainerClassName, withQuickAddToList = _a.withQuickAddToList, domain = _a.domain, renderTag = _a.renderTag, titleTranslationKey = _a.titleTranslationKey, classOverride = _a.classOverride, automationListsPermission = _a.automationListsPermission;
    var t = (0, react_i18next_1.useTranslation)().t;
    var textRef = (0, react_1.useRef)(null);
    var _b = classOverride || {}, divClassName = _b.divClassName, wrapperClassName = _b.wrapperClassName, labelClassName = _b.labelClassName, valueContainerClassName = _b.valueContainerClassName, linkClassName = _b.linkClassName, iconClassName = _b.iconClassName;
    var defaultTitle = (0, overflow_1.isTextOverflowing)(textRef.current) ? value : undefined;
    return (react_1.default.createElement("div", { className: wrapperClassName || 'eva-search-list-view-info-item show-icons' },
        react_1.default.createElement("span", { className: labelClassName || 'eva-search-view-label' }, label),
        react_1.default.createElement("div", { className: "".concat(valueContainerClassName || 'eva-search-info__value-container', " ").concat(customValuesContainerClassName || '') },
            renderTag === 'link' && sanitizedValue && (react_1.default.createElement("a", { className: linkClassName || 'eva-search-view-link', target: "_blank", "data-cy": "".concat(cyName, "-value"), title: t(titleTranslationKey, { VALUE: value }), href: angularJsDependencies.href('app.assignment.search', {
                    filters: encodeURIComponent("".concat(searchText, ":").concat(value)),
                    cursor: null,
                }), dangerouslySetInnerHTML: { __html: sanitizedValue }, rel: "noreferrer", ref: textRef })),
            renderTag === 'span' && (react_1.default.createElement("div", { className: "eva-search-view-value" },
                react_1.default.createElement("span", { "data-cy": "".concat(cyName, "-value") },
                    value,
                    " "))),
            renderTag === 'div' && (react_1.default.createElement("div", { ref: textRef, className: divClassName || 'eva-search-info__value-container__text', title: defaultTitle, "data-cy": "".concat(cyName, "-value") }, value)),
            renderTag === 'none' && (react_1.default.createElement("span", { ref: textRef, title: defaultTitle }, value)),
            chipsToRender,
            react_1.default.createElement("div", { className: iconClassName || 'eva-search-info__icon-container' },
                react_1.default.createElement(CopyIcon_1.default, { value: value }),
                withQuickAddToList && (react_1.default.createElement(QuickAddToList_1.default, { domain: domain, word: value, label: label, automationListsPermission: automationListsPermission })),
                additionalIconsToRender))));
}
exports.default = AdditionalInformationItem;
